import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productPrimaryImageStyles.image = {
    css: css`
        cursor: pointer;
        height: 555px;
        width: 100%;
        min-height: 555px;
        @media all and (max-width: 768px) and (min-width: 0px) {
            height: 378px;
            // width: 314px;
            width: 100%;
            min-height: 378px;
        }
    `,
};

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        margin: 10px 0 10px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        img {
            height: auto;
            max-width: 100%;
            min-height: 100%;
            object-fit: contain;
            max-height:515px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height:400px;
                    `,
                    css`
                        max-height:400px;
                    `,
                    null,
                    null,
                    null
                ])}
        }
    `,
};
